// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__XkVkG","ttl":"styles_ttl__ffVkC","txt":"styles_txt__4PCbE","btnSec":"styles_btnSec__qUCfC","red":"styles_red__LA0Fc"};